import { Widget } from '../../widget';
import TokenSelector from '../../token-selector';
import { useContext } from 'react';
import { IVolatilitySmileComparisonProps } from './types';
import { VolCompareContext } from '../../../../providers/widgets';
import VolatilitySmileComparisonContent from './volatility-smile-comparison-content';
import Source from '../../source';
import WidgetButtons from '../../widget-buttons';
import { CurrencyTypeEnum, VolSurfaceToken } from '../../../../model/currency_type.enum';

const VolatilitySmileComparisonWidget = (props: IVolatilitySmileComparisonProps) => {
  const { widget, actions, permissions } = props;
  const { token, setToken, hasDefaultToken } = useContext(VolCompareContext);
  const handleSetToken = (value: VolSurfaceToken) => setToken(value as CurrencyTypeEnum);

  return (
    <Widget cardKey={widget.key}>
      <Widget.Header>
        <Widget.Title title={widget.title} />
        <Widget.HeaderPanel>
          {<TokenSelector token={token} setToken={handleSetToken} isFixedToken={hasDefaultToken} />}
        </Widget.HeaderPanel>
        <Widget.Buttons>
          <WidgetButtons widget={widget} actions={actions} permissions={permissions} />
        </Widget.Buttons>
      </Widget.Header>
      <Widget.Content>
        <VolatilitySmileComparisonContent providerKey={props.providerKey} />
      </Widget.Content>
      <Widget.Footer>
        <Source source="Deribit" url="https://www.deribit.com" />
      </Widget.Footer>
    </Widget>
  );
};

export default VolatilitySmileComparisonWidget;
